window.dataLayer = window.dataLayer || []
function gtag () {
  dataLayer.push(arguments)
}
gtag('js', new Date())

gtag('config', 'UA-176118812-1')
class EventAnalitic {
  eventAnalitic (eAction, eCategory, eLabel) {
    gtag('event', eAction, {
      event_category: eCategory,
      event_label: eLabel
    })
  }
}

export default EventAnalitic
